import type { FaireProductEntity } from "../../entity_types/product";

export const p_tcbsyfyqaf: FaireProductEntity = {
  token: "p_tcbsyfyqaf",
  type: "product",
  name: "Juniper White Wine Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/dc94f133800932eb9fad252b588a106ac9edd16f94c60d0d5f96ebcdb0472f0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d84da831bfc9e02d26b19b7a8f0926e1a353b455e011bacdbf9a0caeff127d97.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper White Wine glass\nDimension: Ø 8.5cm x H 23cm / Ø 3.3" x H 9"\nCapacity: 340ml / 11.5 fl oz\n\nPacked as a set of 2\n\nColour: clear',
  tags: [],
  msrpDollars: 52.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:31.859Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
